// Cosmetic style maps (ids mirror backend SHOP_FRAMES / SHOP_COLORS).
export const FRAME_STYLES = {
  frame_default: "",
  frame_bronze: "ring-2 ring-amber-600 shadow-[0_0_10px_rgba(180,120,60,0.55)]",
  frame_silver: "ring-2 ring-slate-300 shadow-[0_0_10px_rgba(200,210,230,0.6)]",
  frame_gold: "ring-2 ring-yellow-400 shadow-[0_0_12px_rgba(250,200,50,0.7)]",
  frame_crimson: "ring-2 ring-red-500 shadow-[0_0_12px_rgba(240,60,60,0.7)]",
  frame_celestial: "ring-2 ring-fuchsia-400 shadow-[0_0_16px_rgba(200,120,255,0.85)]",
  frame_fullmoon: "ring-2 ring-slate-100 shadow-[0_0_16px_rgba(226,232,240,0.9)]",
  frame_bloodmoon: "ring-2 ring-red-600 shadow-[0_0_16px_rgba(220,38,38,0.9)]",
  frame_eclipse: "ring-2 ring-orange-400 shadow-[0_0_18px_rgba(251,146,60,0.95)]",
};

export const COLOR_STYLES = {
  color_default: "",
  color_frost: "text-sky-300",
  color_ember: "text-orange-400",
  color_forest: "text-emerald-400",
  color_violet: "text-violet-400",
  color_gold: "text-yellow-400",
  color_aurora: "bg-gradient-to-r from-sky-400 via-fuchsia-400 to-emerald-400 bg-clip-text text-transparent",
};

export const frameClass = (id) => FRAME_STYLES[id] || "";
export const nameColorClass = (id) => COLOR_STYLES[id] || "";
